import React from 'react';
import ValueCard from '../molecules/ValueCard'

const ValuesRow = (props) => {
    const { title, data, loading, className }  = props;
    return (
        <div className={`${className} bg-white rounded shadow p-4`}>
            <h5>{title}</h5>
            <br/>
            <div className="row px-2">
                {
                    data.map(i => (
                        <div className={`col-${12/data.length}`}>
                            <ValueCard
                                className="px-2"
                                title={i.title}
                                value={i.value}
                                format={i.format}
                                loading={loading}
                            />
                        </div>
                       
                    ))
                }
            </div>
        </div>
       
    );
};

export default ValuesRow;
